module.exports = __webpack_public_path__ + "img/4-3.8436f22b.png";